import { create } from 'zustand'
export { useAdmobDatePickerStore } from '@/components/MyDatePicker'

const useAdmobStore = create((set) => ({
  filters: {
    dimensions: ['date'],
    metrics: [
      'estimated_earnings',
      'observed_ecpm',
      'ad_requests',
      'matched_requests',
      'impressions',
      'clicks',
    ],
    pid: 'total',
    country: 'total',
    countries: [],
    package_name: 'total',
    ad_unit: [],
    app_version: [],
    format: [],
  },
  setFilters: (newFilters) =>
    set((state) => ({
      filters: { ...state.filters, ...newFilters },
    })),
  setFilter: (key, value) =>
    set((state) => {
      const newFilters = { ...state.filters, [key]: value }
      if (key === 'pid') {
        newFilters.ad_unit = []
        newFilters.app_version = []
        newFilters.format = []
      }
      return { filters: newFilters }
    }),
}))

export default useAdmobStore
